import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, arabicError } from "../lib/api";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/forgot-password", { email });
      if (r.data.dev_code) toast.message(`رمز التطوير: ${r.data.dev_code}`, { duration: 12000 });
      else toast.success("إذا كان البريد مسجلاً، فقد أُرسل رمز إعادة التعيين.");
      navigate("/reset-password", { state: { email } });
    } catch (err) { toast.error(arabicError(err)); }
    finally { setLoading(false); }
  };

  const inputCls = "h-12 w-full rounded-lg border border-[#7AB2B2] bg-white px-4 focus:outline-none focus:ring-2 focus:ring-[#09637E]";

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#EBF4F6] p-6" dir="rtl">
      <div className="max-w-md w-full bg-white border border-[#7AB2B2] rounded-2xl p-8" data-testid="forgot-page">
        <div className="w-14 h-14 rounded-xl bg-[#EBF4F6] flex items-center justify-center mx-auto mb-4 text-[#09637E]">
          <KeyRound size={28} />
        </div>
        <h2 className="text-2xl font-extrabold text-center text-[#333333] mb-2">نسيت كلمة المرور؟</h2>
        <p className="text-center text-[#666666] mb-6">أدخل بريدك لنرسل لك رمز إعادة التعيين</p>
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="forgot-email-input" className={inputCls} placeholder="example@imdad.com" />
          <button type="submit" disabled={loading} data-testid="forgot-submit"
            className="h-12 w-full rounded-lg bg-[#09637E] hover:bg-[#088395] text-white font-extrabold disabled:opacity-60">
            {loading ? "جارٍ الإرسال..." : "إرسال رمز إعادة التعيين"}
          </button>
        </form>
        <div className="mt-4 text-center text-sm">
          <Link to="/login" className="inline-flex items-center min-h-[44px] px-2 text-[#09637E] font-bold hover:underline">العودة لتسجيل الدخول</Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
